import * as React from "react"
const EditIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={18}
    fill="none"
    {...props}
  >
    <g
      stroke="#2FD4CF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.333}
      clipPath="url(#a)"
    >
      <path d="M3.217 15h3l7.875-7.875a2.12 2.12 0 0 0-3-3L3.217 12v3ZM10.342 4.875l3 3" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.217 0h18v18h-18z" />
      </clipPath>
    </defs>
  </svg>
)
export default EditIcon
